export const FEATURE_REQUEST_CATEGORIES = [
  { value: "scheduling", label: "Scheduling", priority: "P1" },
  { value: "calendar_integrations", label: "Calendar Integrations", priority: "P1" },
  { value: "team_scheduling", label: "Staff/Team Scheduling", priority: "P2" },
  {
    value: "notifications_workflows",
    label: "Notifications & Workflows",
    priority: "P3",
  },
  { value: "user_experience", label: "User Experience", priority: "P4" },
  { value: "integrations", label: "Integrations", priority: "P5" },
  {
    value: "billing_subscription",
    label: "Billing & Subscription",
    priority: "P6",
  },
  { value: "other", label: "Other", priority: "P7" },
];

export const FEATURE_REQUEST_PRIORITIES = [
  { value: "P1", label: "P1 — Scheduling & Calendar Integrations" },
  { value: "P2", label: "P2 — Team Scheduling" },
  { value: "P3", label: "P3 — Notifications & Workflows" },
  { value: "P4", label: "P4 — User Experience" },
  { value: "P5", label: "P5 — Integrations" },
  { value: "P6", label: "P6 — Billing & Subscription" },
  { value: "P7", label: "P7 — Other" },
];

export const getCategoryLabel = (value) => {
  const match = FEATURE_REQUEST_CATEGORIES.find((item) => item.value === value);
  return match ? match.label : "Other";
};

export const getPriorityForCategory = (category) => {
  const match = FEATURE_REQUEST_CATEGORIES.find((item) => item.value === category);
  return match ? match.priority : "P7";
};
